import { Controller } from "@hotwired/stimulus"

// Keeps the consent submit button disabled until every consent checkbox is
// ticked (matching the prototype's consentBtn). Progressive enhancement: with
// JS off the button stays enabled and the checkboxes' `required` attribute
// still blocks submission until all are checked.
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = !this.checkboxTargets.every((cb) => cb.checked)
  }
}
